export default Object.freeze({
  // ETC_PAGE_NOT_FOUND_
  TITLE: '요청하신 페이지를 찾을 수 없습니다.', // ETC_PAGE_NOT_FOUND_TITLE
  DESC1: '방문하시려는 페이지의 주소가 잘못 입력되었거나,',
  DESC2: '페이지의 주소가 변경 혹은 삭제되어 요청하신 페이지를 찾을 수 없습니다.',
  DESC3: '입력하신 주소가 정확한지 다시 한번 확인해 주시기 바랍니다.',
  BTN_BACK: '이전 페이지로',
  BTN_MAIN: '메인으로',
});
